import { useCallback } from 'react'
import {
  handleChangeGTGT,
  handleChangeTableData,
  handleSelectDiscountType,
  handleSelectProduct,
} from '../Function/TableUtils'
import { useAppSelector } from 'hooks/useRedux'

const useInvoiceActions = ({
  formik,
  tableData,
  setTableData,
  setCheckedHHDV,
  roundingConfig,
  isDeliveryBill,
  invoiceType,
  showPriceAfterTax,
  setIsChangeTable,
  isAdjustInvoice,
  persistent,
  systemTaxRate,
}) => {
  const { values, setFieldValue } = formik

  const { formatNumber, invoiceSetting } = useAppSelector(
    (state) => state?.systemConfig,
  )
  const onCheckTaxReduction = useCallback(() => {
    setFieldValue('isTaxReduction', !values.isTaxReduction)
    let newTableData = [...tableData]

    newTableData.forEach((item) => {
      item.taxReduction = 0
      item.taxReductionRate = 0
      item.taxReductionExchange = 0
    })
    setTableData(newTableData)
  }, [values.isTaxReduction, tableData, setTableData, setFieldValue])

  const onChangeCheckHHDV = useCallback(
    (e) => {
      setCheckedHHDV(e.target.checked)
    },
    [setCheckedHHDV],
  )

  const onChangePayment = useCallback(
    (e) => {
      setFieldValue('isPayment', e.target.checked)
    },
    [setFieldValue],
  )

  const onToggleMulTaxRate = useCallback(
    (e) => {
      setFieldValue('multipleTaxRate', e.target.checked)

      let taxRate = values.taxRate
      if (
        (taxRate == '0' ||
          taxRate == '5' ||
          taxRate == '8' ||
          taxRate == '10') &&
        (values.taxType === 1 ||
          values.taxType === 2 ||
          (values.taxType === 3 && !values.multipleTaxRate) ||
          values.multipleTaxRate) &&
        parseInt(values?.serial?.charAt(0)) === 1
      ) {
        taxRate = parseInt(taxRate)
      } else if (taxRate !== 'KHAC') {
        taxRate = 0
      }
      let newTableData = [...tableData]
      newTableData.forEach((item) => {
        item.taxRate = taxRate
        item.unitPrice = (item.unitPriceAfterTax / (100 + taxRate)) * 100
        item.totalUnitPrice = item.unitPrice * item.quantity
        item.taxMoney = (item.totalUnitPrice * taxRate) / 100
      })
      let totalPriceAfterTax = values?.totalAfterTax
      let totalPrice = (totalPriceAfterTax / (100 + taxRate)) * 100
      let taxMoney = (totalPrice * taxRate) / 100
      setFieldValue('total', totalPrice)
      setFieldValue('taxMoney', taxMoney)
      setTableData(newTableData)
    },
    [
      values.taxRate,
      values.multipleTaxRate,
      values.totalAfterTax,
      values.serial,
      values.taxType,
      setFieldValue,
      tableData,
      setTableData,
    ],
  )

  const onChangeTableData = useCallback(
    async (e, row, field, type) => {
      handleChangeTableData({
        e,
        row,
        field,
        type,
        tableData,
        formik,
        setTableData,
        formatNumber,
        roundingConfig,
        isDeliveryBill,
        invoiceType,
        showPriceAfterTax,
        setIsChangeTable,
        isAdjustInvoice,
        persistent,
        invoiceSetting,
        systemTaxRate,
      })
    },
    [
      formatNumber,
      roundingConfig,
      isDeliveryBill,
      invoiceType,
      showPriceAfterTax,
      setIsChangeTable,
      isAdjustInvoice,
      persistent,
      invoiceSetting,
      systemTaxRate,
      tableData,
      formik,
      setTableData,
    ],
  )

  const onChangeGTGT = useCallback(
    (taxRate) => {
      handleChangeGTGT({
        taxRate,
        formik,
        tableData,
        setIsChangeTable,
        showPriceAfterTax,
        setTableData,
      })
    },
    [formik, tableData, setIsChangeTable, showPriceAfterTax, setTableData],
  )

  const onSelectDiscountType = useCallback(
    (discountType) => {
      handleSelectDiscountType({
        discountType,
        tableData,
        formik,
        setTableData,
      })
    },
    [tableData, formik],
  )
  const handleAddRow = useCallback(
    (row, newTableData) => {
      setIsChangeTable(true)
      if (row.no === tableData.length) {
        newTableData = [
          ...newTableData,
          {
            no: tableData.length + 1,
            name: '',
            type: 1,
            discount: parseInt(values.discount ?? 0),
            discountMoney: 0,
            unit: '',
            unitPrice: 0,
            quantity: 0,
            actualExport: 0,
            actualImport: 0,
            totalUnitPrice: 0,
            taxRate: values.multipleTaxRate ? systemTaxRate : values?.taxRate,
            taxReductionRate: 1,
            unitPriceAfterTax: 0,
            totalUnitPriceAfterTax: 0,
            taxMoney: 0,
            productId: 0,
          },
        ]
      }
      setTableData(newTableData)
    },
    [
      tableData.length,
      values.discount,
      values.multipleTaxRate,
      values?.taxRate,
      systemTaxRate,
      setTableData,
      setIsChangeTable,
    ],
  )

  const handleChangeProductNameTableData = useCallback(
    (name, row, type) => {
      let newTableData = [...tableData]
      const row_name = name.target?.value ?? name
      newTableData[row.no - 1].name = row_name
      if (type === 'addRow' && row_name.length > 0) {
        return handleAddRow(row, newTableData)
      }
      return setTableData(newTableData)
    },

    [handleAddRow, setTableData, tableData],
  )

  const onSelectProduct = useCallback(
    (product, row, type) => {
      handleSelectProduct({
        product,
        row,
        type,
        formik,
        tableData,
        isDeliveryBill,
        formatNumber,
        roundingConfig,
        setTableData,
        handleAddRow,
      })
    },
    [
      formik,
      tableData,
      isDeliveryBill,
      formatNumber,
      roundingConfig,
      setTableData,
      handleAddRow,
    ],
  )

  return {
    onCheckTaxReduction,
    onChangeCheckHHDV,
    onChangePayment,
    onToggleMulTaxRate,

    onChangeTableData,
    onChangeGTGT,
    onSelectDiscountType,

    handleAddRow,
    handleChangeProductNameTableData,
    onSelectProduct,
  }
}

export default useInvoiceActions
